<template>
  <div class="linha-quadrado-wrapper">
    <div
      v-for="(_, index) in arBlocos"
      :key="index"
      :class="['linha-quadrado', `${classe}-linha`, { animacaoLinha: index <= contagem }]"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Linha",
  props: {
    numero: String,
    tamanho: String,
    classe: String
  },
  data() {
    return {
      contagem: -1
    };
  },
  mounted() {
    this.contagem = -1;
    this.incremento();
  },
  computed: {
    arBlocos() {
      let array = [];
      for (let index = 0; index < this.numero; index++) {
        array.push("");
      }
      this.contagem = -1;
      return array;
    }
  },
  methods: {
    incremento() {
      if (this.contagem == this.numero) {
        setTimeout(() => {
          this.contagem = -1;
          this.incremento();
        }, 1800);
      } else {
        setTimeout(() => {
          this.contagem += 1;
          this.incremento();
        }, 100);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes linhaFade {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.linha-quadrado-wrapper {
  height: 20px;
  border-radius: 5px;
  border: 1px solid #a1a1a1;
  background: #dadada;
  display: flex;
  padding: 0 3px;
}
.linha-quadrado {
  border-radius: 3px;
  margin: 3px 1px;
  width: 10px;
  background: var(--cinza02);
  opacity: 0;
}
.animacaoLinha {
  animation: linhaFade 2s forwards cubic-bezier(0.39, 0, 0.45, 0.96);
}
.preferencia_tarifaria-linha,
.class_importacao-linha {
  background: var(--importacao);
}

.pis_cofins-linha,
.cide_combustivel-linha {
  background: var(--pis-cofins);
}

.icms_interno-linha,
.icms_st-linha,
.carga_liquida-linha,
.antecipacao-linha,
.difal-linha {
  background: var(--icms);
}

.ipi-linha {
  background: var(--ipi);
}
.verde-linha {
  background: var(--verde2);
}
.vermelho-linha {
  background: var(--vermelho2);
}
.azul-linha {
  background: var(--azul2);
}
</style>
